// extracted by mini-css-extract-plugin
module.exports = {"label":"css_label__1YYUV","subLabel":"css_subLabel__2Dwgl"};